import { useNavigate, useLocation, type NavigateOptions } from "react-router";

export const withQueryParams = (to: string, search: string) => (search && !to.includes("?") ? `${to}${search}` : to);

export const useNavigateWithQueryParams = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  return (to: string, options?: NavigateOptions) => navigate(withQueryParams(to, search), options);
};
